<template>
  <span v-if="role" class="badge bg-blue-lt text-blue-lt-fg ms-1" v-tooltip="tooltip">
    <i class="ti ti-mail me-1"></i>{{ $t('publication.editor.email_role_badge.label') }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import translator from '@/locale/translator';

const props = defineProps<{
  role?: string;
}>();

// falls back to the raw role key if it has no translated description (e.g. an
// emailRole value the badge doesn't know about yet)
const roleLabel = computed(() => {
  if (!props.role) return '';
  const key = `publication.editor.email_role_badge.role.${props.role}`;
  const translated = translator.get(key);
  return translated === key ? props.role : translated;
});

const tooltip = computed(() =>
  translator.get('publication.editor.email_role_badge.tooltip', { role: roleLabel.value })
);
</script>
